import coordinator from "../../img/team/2019/coordinator.jpg";
import newhod from "../../img/team/2019/newhod.jpeg";
import president from "../../img/team/2025/hardik.jpeg";
import vicePresident from "../../img/team/2025/arayan_jotshi.jpeg";
import techLead1 from "../../img/team/2025/aryan.jpeg";
import techLead2 from "../../img/team/2025/vaishnavi.jpeg";
import financeHead2 from "../../img/team/2025/aditya.jpeg";
import financeHead1 from "../../img/team/2025/arayaa.jpeg";
import eventHead1 from "../../img/team/2025/arnav.jpeg";
import eventHead2 from "../../img/team/2025/rajvee.jpeg";
import creativesHead1 from "../../img/team/2025/rohit.png";
import creativesHead2 from "../../img/team/2025/shloka.jpeg";

const team2025 = [
  {
    post: [
      {
        initial: "Dr.",
        name: "P. K.",
        surname: "Deshmukh",
        desc: "Head, Department of Computer Science and Engineering",
        image: newhod,
        mail: "mailto:hod.comp@coep.ac.in",
        about: "https://www.coep.org.in/departments/computerit/aboutdep",
      },
      {
        initial: "Dr.",
        name: "Amit",
        surname: "Joshi",
        desc: "CSI COEP Tech Student Chapter Coordinator",
        image: coordinator,
        mail: "mailto:adj.comp@coep.ac.in",
        about: "https://www.coep.org.in/mycoep/adjcompcoepacin",
      },
    ],
  },
  {
    post: [
      {
        name: "Hardik",
        surname: "Mutha",
        position: "President",
        image: president,
        linkedin: "https://www.linkedin.com/in/hardik-mutha08/",
        github: "https://github.com/HardikMutha",
      },
      {
        name: "Aryan",
        surname: "Jotshi",
        position: "Vice President",
        image: vicePresident,
        linkedin: "https://www.linkedin.com/in/aryan-jotshi-012369292/",
        github: "https://github.com/AryanJotshi",
      },
    ],
  },
  {
    post: [
      {
        name: "Aryan",
        surname: "Mehta",
        position: "Technical Head",
        image: techLead1,
        linkedin:
          "https://www.linkedin.com/in/aryan-mehta-858715276/",
        github: "https://github.com/arymehta",
      },
      {
        name: "Vaishnavi",
        surname: "Shambharkar",
        position: "Technical Head",
        image: techLead2,
        linkedin: "https://www.linkedin.com/in/vaishnavi-shambharkar-8b081028b",
        github: "https://github.com/vaish-navi24",
      },
      {
        name: "Arya",
        surname: "Kulkarni",
        position: "Finance Head",
        image: financeHead1,
        linkedin: "https://www.linkedin.com/in/arya-kulkarni-5898a928b ",
        github: "https://github.com/aryak345",
      },
      {
        name: "Aditya",
        surname: "Jadhav",
        position: "Finance Head",
        image: financeHead2,
        linkedin: "https://www.linkedin.com/in/aditya-jadhav-94371228b",
        github: "https://github.com/adityaj150",
      },
      {
        name: "Arnav",
        surname: "Jadhav",
        position: "Events & Publicity Head",
        image: eventHead1,
        linkedin: "https://www.linkedin.com/in/arnav-jadhav05/",
        github: "https://github.com/Arnav-Jadhav05",
      },
      {
        name: "Rajvee",
        surname: "Shah",
        position: "Events & Publicity Head",
        image: eventHead2,
        linkedin: "https://www.linkedin.com/in/rajvee-shah-6a4904284/",
        github: "https://github.com/rajvee123/",
      },
      {
        name: "Rohit",
        surname: "Chavan",
        position: "Design Head",
        image: creativesHead1,
        linkedin: "https://www.linkedin.com/in/rohitchavan010205",
        github: "https://github.com/itsrohitchavan05",
      },
      {
        name: "Shloka",
        surname: "Shinde",
        position: "Design Head",
        image: creativesHead2,
        linkedin: "https://www.linkedin.com/in/shlokashinde/",
        github: "https://github.com/Shloka-Shinde",
      },
    ],
  },
];

export default team2025;
